/**
 * Formats a number with comma separators for better readability in charts
 * @param value - The number to format
 * @returns Formatted string with comma separators
 */
export const formatChartNumber = (value: number): string => {
	return value.toLocaleString();
};
